import Box from "@mui/material/Box";
import { Link } from "@mui/material";
import Typography from "@mui/material/Typography";
import { makeStyles } from "@material-ui/core/styles";

const LoginHeader = (props) => {
  const classes = useStyles();
  return (
    <>
      <img
        src={props.instituteLogo ? props.instituteLogo : require('../../assets/Vocablab.png')}
        alt="Vocablab"
        loading="lazy"
        className={
          props.instituteLogo ? classes.logoimageBig : classes.logoimage
        }
      />
      <Box>
        <Typography
          sx={{
            fontWeight: 900,
            color: "#DB8829",
            fontSize: "1.3em",
            "@media (min-width: 1636px)": { fontSize: "2rem" },
          }}
        >
          {props.primaryText}
        </Typography>
        <Typography
          sx={{
            fontWeight: 600,
            color: "#DB8829",
            fontSize: "0.8em",
            "@media (min-width: 1636px)": { fontSize: "1.6rem" },
          }}
        >
          {props.secondaryText}
        </Typography>
      </Box>
      {navigator.userAgent.toLowerCase().indexOf("electron/") > -1 && (
        <Link
          underline="none"
          sx={{
            cursor: "pointer",
            fontSize: "1em",
            fontWeight: "500",
            color: "#DB8829",
            paddingX: 5,
            paddingY: 0.5,
            borderRadius: 50,
            border: "1px solid #DB8829",
            "@media (min-width: 1636px)": {
              fontSize: "1rem",
            },
          }}
          onClick={() => {
            window.close();
          }}
        >
          {"Exit"}
        </Link>
      )}
    </>
  );
};

const useStyles = makeStyles({
  logoimage: {
    width: "25em",
    "@media (min-width: 1636px)": { width: "20rem" },
  },
  logoimageBig: {
    width: "30em",
    "@media (min-width: 1636px)": { width: "25rem" },
  },
});
export default LoginHeader;
